import React, { useEffect, useState } from "react";
import ApiService from "../../../services/ApiService";
import {formatDate} from "../../../utils/helper";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const InterviewDetail = () => {
  const [interview, setInterview] = useState(null);
  const [pageLoader, setLoading] = useState(true);

  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const id = urlParams.get("id") ?? "";

  useEffect(() => {

    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await ApiService.get(
        "/getInterviewDetails?interview_id="+id
      );
      setInterview(response.data.data);
    } catch (error) {
      console.error("Error fetching interview details:", error);
      toast.error("Failed to load interview details.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="container mt-5">
      <div className="text-start bg-white mb-4 p-3">
        <h4 className="mb-3 card-head">{interview?.title}</h4>
      </div>
      <div className="row">
        <div className="col-md-12">
          {pageLoader ? (
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="card shadow-sm border-0">
              <div className="card-header bg-white ">
                <span className="badge bg-base fw-semibold float-start">
                  {interview?.category?.title }
                </span>
                <small className="fw-bold float-end">
                  Available Till: {formatDate(interview.user_interview?.expiry_date,'DD MMM YYYY, hh:mm A') || "N/A"}
                </small>
              </div>
              <div className="card-body text-center">
                <div className="bg-light d-flex justify-content-center align-items-center py-3" >
                <video
                    controls autoplay
                    poster={interview.thumbnail} // Thumbnail image
                    controlsList="nodownload" oncontextmenu="return false;"
                    style={{ width: '100%', height:'400px', borderRadius: '10px' }}   >
                    <source src={interview.video} type="video/mp4" />
                    { "Your browser does not support the video tag."}
                </video>
                </div>
                
              </div>
              <p className="mb-4 mx-4 text-left">
                  {interview?.description}
                </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  
};

export default InterviewDetail;
